import dayjs from 'dayjs';

dayjs.extend(require('dayjs/plugin/buddhistEra'));